<template>
  <div class="sample-manage-container main-manage-list-container">
    <sample-list
      class="sample__main-body manage-list__main-body"
      theme="manage"
      :samples="lists"
      :isShowPagination="paginationConfig"
      @onDelete="del"
    ></sample-list>
  </div>
</template>

<script>
import SampleList from '@/pages/sample/_list.vue';
import { mySamples, deleteSample } from '@/api/sample';
import { userDel } from '@/api/common';

export default {
  components: {
    SampleList,
  },
  data() {
    return {
      lists: [],
      pageSize: 15,
      paginationConfig: null,
    };
  },
  computed: {
    page() {
      return this.$route.params.page || 1;
    },
  },
  watch: {
    $route: {
      handler() {
        this.init();
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    init() {
      this.getMySamples();
    },
    async getMySamples() {
      this.$store.commit('openLoading');
      const res = await mySamples({
        page: this.page,
        page_size: this.pageSize,
      });
      const { data } = res;
      this.paginationConfig = data.total;
      this.lists = data.list;
      this.$store.commit('closeLoading');
    },
    del(id) {
      const that = this;
      userDel('确定删除该样品？', () => deleteSample({ id }), () => {
        that.lists = that.lists.filter((item) => Number(item.id) !== Number(id));
      });
    },
  },
};
</script>

<style></style>
